import {get as _get} from 'lodash'
import * as actions from '../actions'
import {toggleGlobalLoader, addSuccessAlert, addErrorAlert} from "./alertLoadingDispatch";
import api from "../api";
import {store} from '../index'
import user from "../reducers/user";
import {getProjectAmountFromProjectImprovements} from '../../utils/projectDataUtils'
import app from "../../App";

let updateApp = data =>  store.dispatch(actions.applicationData.updateApplicationData(data))

export const updateOrCreateApplication = (data) => {

    toggleGlobalLoader(true);
    let promise;
    if (data.id) {
        let update_data = {...data}
        delete update_data.id // remove id to prevent anything odd or ugly on the backend
        promise = () => api.patch(`/project-applications/${data.id}/`, update_data)
    } else {
        promise = () => api.post('/project-applications/', data)
    }

    return new Promise((resolve, reject) => {
        return promise()
            .then((res) => {
                toggleGlobalLoader(false);
                addSuccessAlert("Application updated successfully.");
                store.dispatch(actions.applicationData.updateApplicationData(res.data));
                return resolve({...res.data})
            })
            .catch((err) => {
                toggleGlobalLoader(false);
                addErrorAlert("The application failed to update on our servers.");
                return reject(err)
            })
    })
}




export const prepareApplicationFormFlow = () => {
    let state = store.getState();
    let user = state.user?.decodedTokenData?.user_data || {};
    let applicationResponses = (state.applicationData.app?.data?.responses || [])
        .reduce((r,d) => ({...r, [d.id]: d.response}), {})
    let projectData = state.applicationData.projectLead;

    // prepopulate the form flow
    const user_inputs = {
        name: `${user.first_name} ${user.last_name}`,
        phone: `${user.profile?.phone_1}`,
        email: `${user.email || null}`,
        company: `${user.profile?.company || null}`,
    }

    const form_flow_inputs = {
        ...user_inputs,
        ...applicationResponses,
        project_cost: getProjectAmountFromProjectImprovements(projectData.improvements),
        start_date: projectData.start_date,
    }


    // CLEARING THE FORMFLOW HERE RESETS THE STEP. SO WE SAVE THE STEP AND RESET IT.
    let {currStep} = state.formFlow
    store.dispatch(actions.formFlow.clearFormFlow());
    store.dispatch(actions.formFlow.setFormFlowCurrStep(currStep))
    store.dispatch(actions.formFlow.updateFormFlowInputs(form_flow_inputs));
    store.dispatch(actions.infoFeed.clearInfoFeedDisplay());
}


export const pullApplication = id => {

    return api.get(`/project-applications/${id}/`)
        .then(res => {
            const {data} = res;

            store.dispatch(actions.applicationData.setApplicationIndicative(data.loan_estimate))
            store.dispatch(actions.applicationData.setApplicationProjectLead(data.project.data))
            store.dispatch(actions.applicationData.setApplicationData({
                ...data,
                id: data.id,
                loan_estimate: data.loan_estimate.id,
                project: data.project?.id,
            }))
        })

}




export const mountApplication = ({
        project_id, // this is the only required variable
        projectData, 
        loanEstimateData, 
        applicationData,
        template_id
    }) => {

    let promises = []

    promises.push(
        new Promise(resolve => resolve(loanEstimateData || {}))
    )


    // if we don't have project_data, then we're going to need ot get project_id
    if (!projectData) {
        promises.push(
            api.get(`/project-leads/${project_id}/`).then(res => ({...res.data.data, id: res.data.id}))
        )
    } else {
        promises.push(
            new Promise(resolve => resolve(projectData))
        )
    }

    // we can't expect that application has already been created here.
    // if we don't have application data, then we throw an empty dictionary, becasue the application will be created later
    if (!applicationData) {
        promises.push(
            new Promise(resolve => resolve({}))
        )
    } else {
        promises.push(
            new Promise(resolve => resolve(applicationData))
        )
    }


    // start by getting user data
    toggleGlobalLoader(true)
    return Promise.all(promises) // [estimate, project, application, user]
        .then(results => {

            // set the data in redux
            loanEstimateData = results[0];
            projectData = results[1];
            applicationData = results[2];
            store.dispatch(actions.applicationData.setApplicationIndicative(loanEstimateData));
            store.dispatch(actions.applicationData.setApplicationProjectLead(projectData));
            store.dispatch(actions.applicationData.clearApplicationData());
            store.dispatch(actions.applicationData.updateApplicationData({...applicationData}));
            prepareApplicationFormFlow();
            store.dispatch(actions.formFlow.setFormFlowCurrStep(1));
            toggleGlobalLoader(false);
            return applicationData;

        })
}


export const mergeTemplateToApp = (app_id, template_id, template2template=false) => {
    toggleGlobalLoader(true)
    return api.post('app/merge-template/', {"application": app_id, "merge_template": template_id, "template2template": template2template})
        .then(res => {
            toggleGlobalLoader(false)
            return res.data
        })
        .catch(err => {
            toggleGlobalLoader(false)
            addErrorAlert("Template merge failed.")
            return err
        })
}



export const pullApplicationBids = app_id => {
    return api.get(`/application-bids/?application_id=${app_id}`)
        .then(res => {
            store.dispatch(actions.applicationData.setApplicationBids(res.data))
        })
}


export const submitBid = async (app_id, data) => {
    let res = await api.post(`/application-bids/?application_id=${app_id}`, {data})
        let state = store.getState();
        let curr_app_bids = state.applicationData?.bids || [];
        store.dispatch(actions.applicationData.setApplicationBids([...curr_app_bids, res.data]))
        return res.data
}

export const updateBid = async (app_id, data, metaData) => {
    let res = await api.patch(`/application-bids/${data.id}/?application_id=${app_id}`, {data, ...metaData} )
    let state = store.getState();
    let curr_app_bids = state.applicationData?.bids || [];
    let updated_bids = curr_app_bids.map(b => b.id === res.data.id ? {...b, ...res.data} : b)
    store.dispatch(actions.applicationData.setApplicationBids(updated_bids))
    return res.data

}

